// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"8c235c80","361":"7d55a695","511":"9d2b998c","767":"7ea1a541"}[chunkId] + ".chunk.js";
};